import React from 'react';

/**
 * External link component (tel:, mailto:, etc).
 * No scroll manipulation needed for external links.
 */
const ScrollToTopExternalLink = ({ href, children, className }) => (
  <a href={href} className={className}>{children}</a>
);

export default ScrollToTopExternalLink;
